/**
 * @remotion/google-fonts スタブ
 *
 * remotion/src/lib/fonts.ts が import する @remotion/google-fonts/NotoSansJP の
 * loadFont() を web 用にスタブ化。Google Fonts は index.html の <link> で読み込み済み。
 */
export function loadFont(_style: string, _options: { weights: string[] }): { fontFamily: string } {
  return { fontFamily: '"Noto Sans JP", sans-serif' };
}
